import { Directive, ElementRef } from "@angular/core";

@Directive({
  selector: "[autofocus]",
})
export class AutofocusDirective {
  constructor(private el: ElementRef) {
  }

  ngAfterViewInit() {
    this.el.nativeElement.focus();
  }
}
